<script>
  import { gsap } from "gsap"
  import { onMount } from "svelte"

  import * as utils from "../js/functions.js"
  import { config } from "../js/stores.js"
  import { animStars, animBgStars } from "../js/animations.js"

  const starTypes = [
    { img: "star01.svg", minSize: 2, maxSize: 10 },
    { img: "star02.svg", minSize: 2, maxSize: 10 },
    { img: "star02.svg", minSize: 2, maxSize: 10 },
    { img: "star04.svg", minSize: 2, maxSize: 10 },
    { img: "star05.svg", minSize: 2, maxSize: 10 },
    { img: "star06.svg", minSize: 2, maxSize: 10 },
  ]

  function createStars(domID, num, minSize, maxSize) {
    let container = document.getElementById(domID)
    for (let i = 1; i <= num; i++) {
      let newStar = createRandomStar(minSize, maxSize)
      newStar.id = "star" + i
      newStar.classList.add("star")
      container.appendChild(newStar)
    }
  }

  function createRandomStar(min, max) {
    const star = gsap.utils.random(starTypes)
    const starImg = document.createElement("IMG")

    starImg.src = "images/stars/" + star.img
    starImg.style.width = utils.getRandInt(min, max) + "px"
    starImg.style.opacity = utils.getRandInt(40, 90) / 100
    starImg.style.position = "absolute"
    starImg.style.left = utils.getRandInt(0, 99) + "%"
    starImg.style.top = utils.getRandInt(0, 99) + "%"
    // console.log(starImg);

    return starImg
  }

  onMount(() => {
    createStars("star-container-1", $config.numStars, 7, 12)
    createStars("star-container-2", $config.numStars, 7, 12)
    createStars("star-container-first", $config.numStars, 7, 12)

    createStars("bg-star-container-1", $config.numStars * 3, 2, 6)
    createStars("bg-star-container-2", $config.numStars * 3, 2, 6)
    createStars("bg-star-container-first", $config.numStars * 3, 2, 6)

    animStars()
    animBgStars()
  })
</script>

<div id="star-block-1" class="star-block">
  <div id="star-container-1" class="star-container" />
</div>
<div id="star-block-2" class="star-block">
  <div id="star-container-2" class="star-container" />
</div>
<div id="star-block-first" class="star-block">
  <div id="star-container-first" class="star-container" />
</div>

<div id="bg-star-block-1" class="bg-star-block">
  <div id="bg-star-container-1" class="star-container" />
</div>
<div id="bg-star-block-2" class="bg-star-block">
  <div id="bg-star-container-2" class="star-container" />
</div>
<div id="bg-star-block-first" class="bg-star-block">
  <div id="bg-star-container-first" class="star-container" />
</div>

<style>
  .star-block,
  .bg-star-block {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    overflow: hidden;
    z-index: 0;
  }

  .bg-star-block {
    z-index: -100;
  }

  #star-block-1 {
    /* background: red; */
  }

  #star-block-2 {
    /* display: none; */
    /* background: lightgreen; */
  }

  .star-container {
    position: relative;
    height: 100vh;
    overflow: hidden;
  }

  .star {
    position: absolute;
  }
</style>
